import { PayloadAction, createSlice } from "@reduxjs/toolkit"

import { logout } from "../actions/auth"
import { AllCampaignsListState } from "../actions/campaigns"
import {
	CampaignsState,
	CorporatesState,
	getUserAllCorporates,
} from "../actions/corporates"

const initialState: AllCampaignsListState = {
	loading: false,
	error: undefined,
	list: [],
	selected: undefined,
}

const campaignSlice = createSlice({
	name: "campaigns",
	initialState: initialState,
	reducers: {
		clearError: (state: AllCampaignsListState) => {
			state.error = undefined
			state.loading = false
		},
		resetDefault: (state: AllCampaignsListState) => {
			state.loading = false
			state.loadingFetch = false
			state.error = undefined
			state.errorFetch = undefined
			state.selected = undefined
		},
		selectCampaign: (
			state: AllCampaignsListState,
			action: PayloadAction<CampaignsState | undefined>
		) => {
			state.selected = action?.payload
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(logout.fulfilled, () => initialState)
			.addCase(getUserAllCorporates.pending, (state: AllCampaignsListState) => {
				state.loading = true
				state.error = undefined
			})
			.addCase(
				getUserAllCorporates.fulfilled,
				(
					state: AllCampaignsListState,
					action: PayloadAction<CorporatesState[]>
				) => {
					state.loading = false
					state.error = undefined
					state.list = action?.payload?.flatMap(
						(corporate) => corporate.campaigns
					)
				}
			)
			.addCase(
				getUserAllCorporates.rejected,
				(state: AllCampaignsListState, action) => {
					state.loading = false
					state.error = action?.payload.message
				}
			)
	},
})

export const { clearError, resetDefault, selectCampaign } =
	campaignSlice.actions

export default campaignSlice.reducer
